import React from 'react';
import Views from '.';
import FullBodyMenu from './full-body/full-menu';

const FullBodyMenuView = ({title, ...props}) => {
  return (
    <Views title={title}>
      <FullBodyMenu {...props} />
    </Views>
  );
};

export default FullBodyMenuView;
